import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DefaultDataEditGridConfig } from '~/components/DataGridCustom';
import { defaultTextFieldProps } from '~/components/DataGridCustom/common/defaults';
import { SupplierAutocomplete } from '~/components/SupplierAutocomplete';

interface DateEditCellProps<R extends GridValidRowModel> extends GridRenderCellParams<R>, DefaultDataEditGridConfig {}

export const SupplierEditCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>({
  colDef,
  getRowIndex,
  keyPrefix,
  languageNamespace,
  pathPrefix,
  row,
  textFieldProps,
}: DateEditCellProps<R>) => {
  const p = [...(pathPrefix ?? []), getRowIndex?.(row.id), colDef.field];
  const { t: tPrefix } = useTranslation(languageNamespace, { keyPrefix });

  return (
    <Controller
      name={p.join('.')}
      defaultValue=""
      render={({ field, fieldState: { error } }) => {
        return (
          <SupplierAutocomplete
            {...field}
            fullWidth
            simplifyValue
            TextFieldProps={{
              label: tPrefix(colDef.field),
              error: !!error,
              ...defaultTextFieldProps,
              ...textFieldProps,
            }}
          />
        );
      }}
    />
  );
};
